module.exports = __webpack_public_path__ + "static/images/hero.c0a4f910b15c47858e3c2279a6d8ad59.jpg";